
import React from 'react';
import PrayerChoiceDialog from './PrayerChoiceDialog';
import AiPrayerAssistantModal from '../ai-assistant/AiPrayerAssistantModal';
import ModalErrorBoundary from './ModalErrorBoundary';
import { PrayerCompanion } from '../companion/PrayerCompanion';
import { CompanionContent } from '../companion/CompanionContent';
import UniversalPrayerEntry from './UniversalPrayerEntry';
import { usePrayerChoice } from '@/contexts/PrayerChoiceContext';

export default function GlobalPrayerChoiceController() {
  const {
    isOpen,
    choiceContext,
    isAiAssistantOpen,
    isCompanionOpen,
    companionMode,
    closeChoiceDialog,
    handleINeedPrayer,
    handleIWantToPray,
    closeAiAssistant,
    closeCompanion
  } = usePrayerChoice();

  return (
    <>
      {/* Universal Prayer Entry - Always visible floating icon */}
      <UniversalPrayerEntry />
      
      {/* Prayer Choice Dialog - Only for contextual prayers */}
      {isOpen && (
        <ModalErrorBoundary>
          <PrayerChoiceDialog
            isOpen={isOpen}
            onClose={closeChoiceDialog}
            onINeedPrayer={handleINeedPrayer}
            onIWantToPray={handleIWantToPray}
            prayerContext={choiceContext}
          />
        </ModalErrorBoundary>
      )}
      
      {/* AI Prayer Assistant Modal - Always render when open */}
      {isAiAssistantOpen && (
        <ModalErrorBoundary>
          <AiPrayerAssistantModal
            isOpen={isAiAssistantOpen}
            onClose={closeAiAssistant}
          />
        </ModalErrorBoundary>
      )}

      {/* Prayer Companion - New full-screen experience */}
      <PrayerCompanion visible={isCompanionOpen} onClose={closeCompanion}>
        <CompanionContent />
      </PrayerCompanion>
    </>
  );
}
